import classNames from 'classnames';

import './style.css';

const Container = ({ children, className }) => {
	const classes = classNames('Container', className);

	return <div className={classes}>{children}</div>;
};

export default Container;
